export default function MarketingPageWrapper({
  children,
}) {
  return (
    <div className="bg-gray-100">
      {children}
    </div>
  );
}
